import Sortable from "sortablejs";

// Admin-only drag & drop reordering of tag pills (x-tags component).
// Containers are rendered with [data-tag-reorder] only for super_admin users;
// the server re-checks the role on every request.
function initTagReorder() {
    document.querySelectorAll("[data-tag-reorder]").forEach((container) => {
        if (container.dataset.tagReorderInit) {
            return;
        }
        container.dataset.tagReorderInit = "1";

        Sortable.create(container, {
            draggable: "[data-tag-id]",
            animation: 150,
            ghostClass: "opacity-50",
            onEnd: () => {
                const ids = Array.from(
                    container.querySelectorAll("[data-tag-id]")
                ).map((el) => Number(el.dataset.tagId));

                if (ids.length < 2) {
                    return;
                }

                fetch("/api/tags/reorder", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "X-CSRF-TOKEN":
                            document.querySelector('meta[name="csrf-token"]')
                                ?.content ?? "",
                    },
                    body: JSON.stringify({ ids }),
                })
                    .then((response) =>
                        response.ok
                            ? response.json()
                            : Promise.reject(response)
                    )
                    .then((data) => window.toastr?.success(data.message))
                    .catch(() =>
                        window.toastr?.error(
                            "Could not save the tag order — reload and try again."
                        )
                    );
            },
        });
    });
}

document.addEventListener("DOMContentLoaded", initTagReorder);
document.addEventListener("livewire:navigated", initTagReorder);
